import './types/global.d.ts';
import '../stylesheets/all.scss';
import 'es6-object-assign/auto';
import { GA } from './ga';
import { GTM } from './gtm';
import { List } from './catalog';
import ProductCard from './productCard/_productCard';
import UI from './ui';
import SwiperSlider from './ui/_SwiperSlider';

// eslint-disable-next-line id-length

const arUrl = window.location.pathname.split('/');
const UrlParams = window.location.search;

const firstChunkUrl = 1;
const secondChunkUrl = 2;

if (arUrl[firstChunkUrl] === 'order' && UrlParams.indexOf('?ORDER_ID') < 0) {
    (window as any).BX.Sale.OrderAjaxComponent = {};
    (window as any).BX.Sale.OrderAjaxComponent.sendRequest = () => {
        return false;
    };
}

document.addEventListener('DOMContentLoaded', async (event) => {
    import('./header').then(({ Header: header }) => {
        header.fixedMenu();
    });
    import('./breadcrumbs').then(({ Breadcrumbs: breadcrumbs }) => {
        breadcrumbs.openFullBreadcrumbs();
    });
    UI.init();
    switch (arUrl[firstChunkUrl]) {
        case 'basket':
            break;
        case 'product':
            import('./productCard').then(({}) => {
                new ProductCard();
            });
            break;
        case 'personal': {
            if (arUrl[secondChunkUrl] === 'referral') {
                import('./referral/ReferralComponent').then(
                    ({ default: _referral }) => {
                        return new _referral();
                    }
                );
            }
            break;
        }
        case '':{
            SwiperSlider.initMainBannerSwiper();
            break;
        }
        default:
            break;
    }

    GTM.init(arUrl);
    List.init();
});
document.addEventListener('ajaxListReload', async (event) => {
    List.init();
});
window.addEventListener('resize', (event) => {
    UI.dottedMenu();
});
window.addEventListener('load', (event) => {
    UI.dottedMenu();
    switch (arUrl[firstChunkUrl]) {
        case 'order':
        case 'basket': {
            if (UrlParams.indexOf('?ORDER_ID') === 0) {
                import('./checkout/CheckoutResult').then(
                    ({ default: _checkout_result }) => {
                        return new _checkout_result();
                    }
                );
            } else {
                import('./checkout').then(
                    ({ CheckoutComponent: _checkout }) => {
                        const { BX } = window as any;
                        const { arResult } = window as any;
                        const { ymaps } = window as any;
                        const { boxberry } = window as any;
                        const checkout = new _checkout(
                            arResult,
                            BX,
                            ymaps,
                            boxberry
                        );

                        checkout.init();
                        BX.Sale.OrderAjaxComponent = checkout;
                    }
                );
            }
            break;
        }
        default:
            break;
    }
    GA.init(arUrl);
});
